module.exports = __webpack_public_path__ + "img/radio-button-success.60ddd23e.svg";